import { createRouter, createWebHistory } from 'vue-router'
import { getAdminToken } from '../services/api'
import Home from '../views/Home.vue'
import Categoria from '../views/Categoria.vue'
import Login from '../views/Login.vue'
import Picking from '../views/Picking.vue'
import EnderecosPicking from '../views/EnderecosPicking.vue'
import ProximoItemPicking from '../views/ProximoItemPicking.vue'
import Cancelamento from '../views/Cancelamento.vue'
import EnderecosCancelamento from '../views/EnderecosCancelamento.vue'
import ProximoItemCancelamento from '../views/ProximoItemCancelamento.vue'
import Inventario from '../views/Inventario.vue'
import InventarioDetalhes from '../views/InventarioDetalhes.vue'
import InventarioContagem from '../views/InventarioContagem.vue'
import MovimentacaoDePara from '../views/MovimentacaoDePara.vue'
import MovimentacaoInterna from '../views/MovimentacaoInterna.vue'
import ConsultarChaveNota from '../views/ConsultarChaveNota.vue'
import PrimeiraConferencia from '../views/PrimeiraConferencia.vue'
import SegundaConferencia from '../views/SegundaConferencia.vue'
import BaixaRecebimento from '../views/BaixaRecebimento.vue'
import EntradaManual from '../views/EntradaManual.vue'
import Expedicao from '../views/Expedicao.vue'
import PreExpedicao from '../views/PreExpedicao.vue'
import SaidaManual from '../views/SaidaManual.vue'
import Modificar from '../views/Modificar.vue'
import EditarPedido from '../views/EditarPedido.vue'
import ConsultaPedidos from '../views/ConsultaPedidos.vue'
import consultaPedidoResultado from '../views/ConsultaPedidoResultado.vue'
import ConsultaProdutos from '../views/ConsultaProdutos.vue'
import ConsultaProdutoResultado from '../views/ConsultaProdutoResultado.vue'
import ConsultaProdutosPorEndereco from '../views/ConsultaProdutosPorEndereco.vue'
import Atividades from '../views/Atividades.vue'
import RessuprimentoPulmao from '../views/RessuprimentoPulmao.vue'
import MovimentacaoShelflife from '../views/MovimentacaoShelflife.vue'
import ContagemEstoque from '../views/ContagemEstoque.vue'
import Cubagem from '../views/Cubagem.vue'

// Vue.use(VueRouter) // Removed in Vue 3

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/categoria/:idmenu',
    name: 'Categoria',
    component: Categoria
  },
  { path: '/', redirect: '/home' },

  // PICKING ===================================================================

  {
    path: '/picking',
    name: 'Picking',
    component: Picking
  },
  {
    path: '/picking/enderecos/:id',
    name: 'EnderecosPicking',
    component: EnderecosPicking,
    props: true
  },
  {
    path: '/picking/proximo-item/:id',
    name: 'ProximoItemPicking',
    component: ProximoItemPicking,
    props: true
  },

  // CANCELAMENTO ==============================================================

  {
    path: '/cancelamento',
    name: 'Cancelamento',
    component: Cancelamento
  },
  {
    path: '/cancelamento/enderecos/:id',
    name: 'EnderecosCancelamento',
    component: EnderecosCancelamento,
    props: true
  },
  {
    path: '/cancelamento/proximo-item/:id',
    name: 'ProximoItemCancelamento',
    component: ProximoItemCancelamento,
    props: true
  },

  // INVENTÁRIO ===============================================================

  {
    path: '/inventario',
    name: 'Inventario',
    component: Inventario,
    props: true
  },
  {
    path: '/inventario/detalhes/:id',
    name: 'InventarioDetalhes',
    component: InventarioDetalhes,
    props: true
  },
  {
    path: '/inventario/contagem/:id/:conferencia',
    name: 'InventarioContagem',
    component: InventarioContagem,
    props: true
  },

  // MOVIMENTACAO ============================================================

  {
    path: '/movimentacao/depara',
    name: 'MovimentacaoDePara',
    component: MovimentacaoDePara,
    props: true
  },
  {
    path: '/movimentacao/interna',
    name: 'MovimentacaoInterna',
    component: MovimentacaoInterna,
    props: true
  },
  {
    path: '/saidamanual',
    name: 'SaidaManual',
    component: SaidaManual,
    props: true
  },
  {
    path: '/entradamanual',
    name: 'EntradaManual',
    component: EntradaManual,
    props: true
  },

  // INBOUND =================================================================
  {
    path: '/consultarchavenota',
    name: 'ConsultarChaveNota',
    component: ConsultarChaveNota,
    props: true
  },
  {
    path: '/primeiraconferencia',
    name: 'PrimeiraConferencia',
    component: PrimeiraConferencia,
    props: true
  },
  {
    path: '/segundaconferencia',
    name: 'SegundaConferencia',
    component: SegundaConferencia,
    props: true
  },
  {
    path: '/baixarecebimento',
    name: 'BaixaRecebimento',
    component: BaixaRecebimento,
    props: true
  },

  {
    path: '/cubagem',
    name: 'Cubagem',
    component: Cubagem,
    props: true
  },

  // OUTBOUND =================================================================
  {
    path: '/preexpedicao',
    name: 'PreExpedicao',
    component: PreExpedicao,
    props: true
  },
  {
    path: '/expedicao',
    name: 'Expedicao',
    component: Expedicao,
    props: true
  },

  // MODIFICAR =================================================================
  {
    path: '/modificar',
    name: 'Modificar',
    component: Modificar,
    props: true
  },
  {
    path: '/pedido/editar',
    name: 'EditarPedido',
    component: EditarPedido,
    props: true
  },

  // CONSULTA =================================================================
  {
    path: '/consulta/pedidos',
    name: 'Consulta',
    component: ConsultaPedidos,
    props: true
  },
  {
    path: '/consulta/pedido/resultado/:pedido',
    name: 'consultaPedidoResultado',
    component: consultaPedidoResultado,
    props: true
  },
  {
    path: '/consulta/produtos',
    name: 'Produtos',
    component: ConsultaProdutos,
    props: true
  },
  {
    path: '/consulta/produto/detalhes/:idproduto',
    name: 'ConsultaProdutoResultado',
    component: ConsultaProdutoResultado,
    props: true
  },
  {
    path: '/consulta/produtos/endereco',
    name: 'ConsultaProdutosPorEndereco',
    component: ConsultaProdutosPorEndereco,
    props: true
  },

  // ATIVIDADES ===============================================================

  {
    path: '/atividades',
    name: 'Atividades',
    component: Atividades,
    props: true
  },
  {
    path: '/atividade/ressuprimentopulmao/:id',
    name: 'RessuprimentoPulmao',
    component: RessuprimentoPulmao,
    props: true
  },
  {
    path: '/atividade/movimentacaoshelflife/:id',
    name: 'MovimentacaoShelflife',
    component: MovimentacaoShelflife,
    props: true
  },

  {
    path: '/atividade/contagem_estoque/:id',
    name: 'ContagemEstoque',
    component: ContagemEstoque,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  let isAuthenticated = getAdminToken();
  document.querySelector('body').scrollTo(0, 0);

  const modals = document.querySelectorAll('.modal.show'); // Seleciona os modais abertos
  modals.forEach((modal) => {
    const backdrop = document.querySelector('.modal-backdrop'); // Seleciona o fundo do modal

    // Remove a classe `.show` para ocultar o modal
    modal.classList.remove('show');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');

    // Remove o fundo do modal, se existir
    if (backdrop) {
      backdrop.parentNode.removeChild(backdrop);
    }
  });

  if (to.name !== 'Login' && !isAuthenticated) {
    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router
